import service from '@/services/superaccess'

const zone = {
  state: {
    zone_modal: false,
    zones: [],
    names: []
  },
  mutations: {
    setModalZoneStatus (state, status) {
      state.zone_modal = status
    },
    pushZones (state, zone) {
      state.zones.push(zone)
    },
    setZones (state, zones) {
      state.zones = zones
    },
    setNames (state, names) {
      state.names = names
    }
  },
  getters: {
    getStatusZoneModal (context) {
      return context.zone_modal
    },
    getZones (context) {
      return context.zones
    },
    getNames (context) {
      return context.names
    }
  },
  actions: {
    changeNamesZones (context, payload) {
      context.commit('setNames', payload)
    },
    changeModalZoneStatus (context, payload) {
      context.commit('setModalZoneStatus', payload)
    },
    pushZone (context, payload) {
      context.commit('pushZones', payload)
    },
    storeZone (context, payload) {
      context.commit('setZones', payload)
    },
    retriveZone (context, payload) {
      return service.post('/api/zone/show', context)
    },
    retriveZoneName (context, payload) {
      return service.post('/api/zone/get-names', context)
    },
    saveZone (context, payload) {
      return service.post('/api/zone/create', context, { zone: payload })
    },
    updateZone (context, payload) {
      return service.patch('/api/zone/modify', context, { zone: payload })
    },
    changeZoneStatus (context, payload) {
      return service.patch('/api/zone/change', context, payload)
    },
    setStatusZoneModal (context, payload) {
      context.commit('updateStatusZoneModal', payload)
    }
  }
}

export default zone



// WEBPACK FOOTER //
// app/javascript/src/store/zone.js